import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { AppProfile } from 'src/app/shared/app-profile/app-profile';

@Injectable({
  providedIn: 'root'
})
export class PatientDeviceAssignmentService {
  deleteDeviceRequest(tenantId: string, deviceRequestId: any, token: string) {
    throw new Error('Method not implemented.');
  }
  private baseUrl = this.appProfile.ampmUs+'/ems/fhir';
  private tenantId = this.appProfile.tenant;
  private apiVersion = '1.0.0';

  constructor(private http: HttpClient, private authService: AuthService, private appProfile: AppProfile) { }
  createDeviceRequest(deviceRequest: any): Observable<any> {
    const url = `${this.baseUrl}/${this.tenantId}/DeviceRequest`;

    const headers = new HttpHeaders({
      'X-tenant-Id': this.tenantId,
      'api-version': this.apiVersion,
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.authService.accessToken}`,
    });

    return this.http.post(url, deviceRequest, { headers });
  }
}
